module.exports = __webpack_public_path__ + "static/media/coliseu_box_12.219a2160.jpg";